import { hours, mins } from '@repo/utils'

/**
 * Freshness policy for the borrower/market candidate list, shared by the server cache unit and the UI
 * that reports its age.
 *
 * Deliberately **not** `server-only`: `borrowers.data.ts` configures the `liquidation-candidates`
 * cache unit from these values and `CandidateListAge` renders against the same numbers, so a change
 * to the policy can't leave the UI claiming a cutoff that no longer exists.
 */
export const CANDIDATES_TTL_SECS = mins(1).toSecs()

/** The last-known-good window: past this a read is a hard miss and the procedure throws. */
export const CANDIDATES_EXPIRY_SECS = hours(6).toSecs()

/**
 * Above `ttl`, so a single in-flight revalidation doesn't trip it. Crossing it means the list is
 * older than its refresh window — which happens both when revalidation is failing and when nothing
 * has read the entry for a while, so the copy keyed off it must not name a cause.
 */
export const CANDIDATES_WARNING_AFTER_MS = mins(3).toMs()

/** How close to `expiry` the age must get before it is reported as severe. */
export const CANDIDATES_SEVERE_WITHIN_MS = mins(30).toMs()

export const CANDIDATES_EXPIRY_MS = CANDIDATES_EXPIRY_SECS * 1000

/** Human-readable expiry for copy, derived so the string can't drift from the policy. */
export const CANDIDATES_EXPIRY_LABEL = `${CANDIDATES_EXPIRY_SECS / hours(1).toSecs()}h`
